snt-feature-right {
  display: flex;
  align-items: stretch;

  .article-container {
    position: relative;
    box-shadow: 0.2px 0.2px 10px $color-grey-06;
    height: 308px;
    width: 100%;
  }

  a {
    display: flex;
    align-items: stretch;
    text-decoration: none;
    width: 100%;
  }

  a:focus,
  a:active,
  a:hover {
    border: none;
    outline: none;
    text-decoration: none;
    .article-container {
      outline: 5px solid $color-primary-accent;
    }
  }

  .article-img {
    height: 174px;
  }

  .article-img img {
    object-fit: cover;
    width: 100%;
    height: 174px;
  }

  snt-image {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .article-tag {
    position: absolute;
    background-color: $color-secondary-medium;
    color: $color-black;
    left: 0px;
    font-family: "Averta-ExtraBold";
    font-weight: 400;
    text-transform: uppercase;

    padding: 9px 15px;
    top: 147px;
    font-size: 14px;
    line-height: 22px;
  }

  .article-content {
    padding: 30px 15px;
  }

  .article-title {
    position: relative;
    color: $color-black;
    text-align: left;
    font-size: 14px;
    line-height: 21px;
  }

  .article-min-read {
    position: absolute;
    color: $color-hint;
    font-family: "Averta-Regular";
    left: 15px;
    bottom: 15px;
    font-size: 12px;
    line-height: 18px;
  }

  .h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  @include viewport($viewport-md) {
    .article-container {
      display: grid;
      grid-template-columns: 0px auto;
      height: 141px;
    }

    .article-tag {
      top: 0px;
      padding: 9px 15px;
      font-size: 14px;
      line-height: 22px;
    }

    .article-content {
      padding: 15px;
    }

    .article-title {
      margin-top: 35px;
      margin-bottom: auto;
    }
  }

  @include viewport($viewport-lg) {
    .article-container {
      display: grid;
      grid-template-columns: 156px auto;
      height: 156px;
    }

    .article-img {
      height: 156px;
      width: 156px;
    }

    .article-img img {
      height: 156px;
      width: 156px;
    }

    .article-tag {
      top: 0px;
      padding: 9px 20px 8px;
      font-size: 14px;
      line-height: 23px;
    }

    .article-content {
      position: relative;
      padding: 20px;
    }

    .article-title {
      margin-top: 30px;
      margin-bottom: auto;
    }

    .article-title-text {
      font-size: 16px;
      line-height: 21px;
    }

    .article-min-read {
      bottom: 20px;
      font-size: 14px;
      line-height: 20px;
    }

    .h4 {
      -webkit-line-clamp: 3;
    }
  }

  @include viewport($viewport-xl) {
    .article-container {
      display: grid;
      grid-template-columns: 187px auto;
      height: 187px;
    }

    .article-img {
      height: 187px;
      width: 187px;
    }

    .article-img img {
      height: 187px;
      width: 187px;
    }

    .article-tag {
      top: 0px;
      padding: 9px 20px 8px;
      font-size: 14px;
      line-height: 23px;
    }

    .article-content {
      position: relative;
      padding: 20px;
    }

    .article-title {
      margin-top: 36.09px;
      margin-bottom: auto;
      font-size: 16px;
      line-height: 21px;
    }

    .article-min-read {
      bottom: 26px;
      font-size: 14px;
      line-height: 20px;
    }

    .h4 {
      -webkit-line-clamp: 3;
    }
  }
}
